/**
 * reactionCopy — the one FAILURE line for a reaction the store refused
 * (D9: code authors failure copy only). Until 2026-09-09 a refused write
 * rolled the chip back silently — "it flashed and disappeared".
 */
export function reactionRefusedLine(lang: 'en' | 'es'): string {
  return lang === 'es'
    ? 'no se pudo guardar esa reacción — inténtalo de nuevo en un momento.'
    : "couldn't save that reaction — try again in a moment.";
}
